// import React from "react";
import "../styles/contact.css";
import bg from "../assets/contactus/contactbg.webp"; // Your bg image
import React, { useState } from "react"; // (at the top with your other imports)

import Contactform from "../components/Contactform";

const faqs = [
  {
    question: "How do I book a consultation?",
    answer:
      "You can fill out the contact form or call us directly on +971 43827715. Our first consultation is free.",
  },
  {
    question: "Can I get virtual assistance?",
    answer:
      "Yes, we offer both in-person and remote consultations via Zoom meetings/Google meets.",
  },
  {
    question: "How often should I review my financial strategy?",
    answer:
      "Your portfolio should be analysed in regard to the goals you've set. We recommend that our clients review their portfolios quarterly or every six months, depending on the modifications that are required.",
  },
  {
    question:
      "Do I need critical illness insurance if I already have life cover?",
    answer:
      "Life insurance supports your family after your death, while critical illness cover helps during a serious illness by managing treatment costs and temporary income loss.",
  },
  {
    question: "Can you help with both tax-saving and investment planning?",
    answer:
      "Yes, we help you choose the right tax-saving instruments, aligning your investments with your financial goals and risk profile.",
  },
  {
    question: "Do you offer support for real estate and mortgage planning?",
    answer:
      "We specialize in identifying suitable properties and offer guidance on mortgage eligibility, loan options, and financing strategy based on your financial goals.",
  },
];

// const [openIndex, setOpenIndex] = useState(null);
function Contact() {
  const [openIndex, setOpenIndex] = useState(null);
  return (
    <main className="main-section">
      <section className="contactus-main">
        {/* Background image as element */}
        <img src={bg} alt="Background" className="contactus-bg-img" />

        <div className="contactus-overlay">
          {/* Title */}''
          <h1 className="contactus-title">Contact Us</h1>
          <div className="contactus-subtitle">
            We are global management consulting firm to help with financial
            business
          </div>
          {/* Info Cards */}
          <div className="contactus-info-row">
            <div className="contactus-info-card">
              <div className="contactus-info-icon">
                <i className="fas fa-phone"></i>
              </div>
              <div className="contactus-info-text">+971 43827715</div>
            </div>
            <div className="contactus-info-card">
              <div className="contactus-info-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div className="contactus-info-text">info@serenityy.ae</div>
            </div>
            <div className="contactus-info-card">
              <div className="contactus-info-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div className="contactus-info-text">
                19th Floor, Conrad Dubai, Trade Center 1, Sheikh Zayed Road,
                <br />
                Dubai, U.A.E, P.O. Box- 5610
              </div>
            </div>
          </div>
          {/* Map + Form */}
          <div className="contactus-content-row">
            <div className="contactus-map-card">
              <iframe
                title="Conrad Dubai Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.3343777018194!2d55.2840912!3d25.225660299999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f42ee8879e54b%3A0x18c04cc22bfbd904!2sConrad%20Dubai!5e0!3m2!1sen!2sin!4v1749929595542!5m2!1sen!2sin"
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ border: 0, borderRadius: "32px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <Contactform />
          </div>
        </div>
      </section>

      {/* ...existing Contact form code above */}

      <section className="faq-section">
        <h2 className="faq-title">FAQs</h2>
        <div className="faq-list">
          {faqs.map((item, idx) => (
            <div
              key={idx}
              className={`faq-item${openIndex === idx ? " open" : ""}`}
              onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
            >
              <div className="faq-question-row">
                <span className="faq-qnumber">Q{idx + 1}</span>
                <span className="faq-question">{item.question}</span>
                <span className={`faq-icon${openIndex === idx ? " open" : ""}`}>
                  {openIndex === idx ? (
                    <span>&#8722;</span>
                  ) : (
                    <span>&#43;</span>
                  )}
                </span>
              </div>
              <div
                className="faq-answer-wrapper"
                style={{
                  maxHeight: openIndex === idx ? "400px" : "0",
                  opacity: openIndex === idx ? 1 : 0,
                  // paddingTop: openIndex === idx ? "30px" : "0",
                }}
              >
                <hr />
                <div className="faq-answer">{item.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

export default Contact;
